import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export function AuthShell({ title, subtitle, children, testid }) {
  return (
    <div className="min-h-screen brand-gradient flex flex-col" data-testid={testid}>
      <div className="max-w-6xl w-full mx-auto px-6 py-6">
        <Link to="/" className="flex items-center"><Logo variant="auth" className="h-7 w-auto" /></Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-6 pb-20">
        <div className="w-full max-w-[400px] animate-fade-up">
          <h1 className="text-3xl md:text-[34px] font-semibold tracking-display text-[#292827] leading-tight">{title}</h1>
          {subtitle && <p className="mt-3 text-[15px] text-[#6E675C]">{subtitle}</p>}
          <div className="mt-9">{children}</div>
        </div>
      </div>
    </div>
  );
}

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function googleLogin() {
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}
